import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";

//查询列表 POST /simShipmentBatch/findList
export  const findList =(page,params)=>{
    return http.postJSON("/simShipmentBatch/findList?"+jsonToFormData(page),params);
  }

//新增 POST /simShipmentBatch/insert
export function add(params){
    return http.postJSON("/simShipmentBatch/insert",params);
  }

//编辑 POST /simShipmentBatch/edit 
export function edit(params){
    return http.postJSON("/simShipmentBatch/edit",params);
  }

  //GET /simShipmentBatch/exportExcel
  export function exportExcel(params) {
    return http.getExcel("/simShipmentBatch/exportExcel",params,"导出")
 }


// WEBPACK FOOTER //
// ./src/services/batch.js